import { mdiHomeAnalytics } from "@mdi/js";
const generalNav = [
  {
    title: "Général",
    icon: mdiHomeAnalytics,

    children: [
      {
        title: "Dashboard",
        to: {
          name: "general-dashboard",
        },
        resource: "general",
        action: "manage",
      },
      {
        title: "Dashboard V2",
        to: {
          name: "general-dashboard-v2",
        },
        resource: ["general", "dashboard_v2"],
        action: "manage",
      },
      {
        title: "Données du groupe",
        to: {
          name: "rwm-data",
        },
        resource: "general",
        action: "manage",
      },
      {
        title: "GA par site",
        to: {
          name: "ga-sites-main",
        },
        resource: "general",
        action: "manage",
      },
    ],
  },
];

export default generalNav;
